import { Seo } from "@/components/Seo";
import { PageHero } from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import { SolarCalculator } from "@/components/SolarCalculator";

export default function CalculatorPage() {
  return (
    <>
      <Seo
        title="Solar Calculator — Calculate Your Solar Requirement & Savings | DHIYAA SOLAR ENERGY"
        description="Calculate your indicative solar capacity, annual generation, savings, system cost and PM Surya Ghar subsidy for your home, business or industry in Chennai and Tamil Nadu."
      />
      <PageHero
        eyebrow="Solar Calculator"
        title="Calculate Your Solar Requirement"
        subtitle="Enter your electricity details and get an indicative solar estimate — capacity, generation, savings and subsidy."
      />
      <section className="mx-auto max-w-7xl px-4 py-16 sm:px-6" data-testid="calculator-page">
        <Reveal>
          <div className="rounded-3xl border border-slate-100 bg-white p-6 shadow-xl sm:p-10">
            <SolarCalculator source="calculator-page" />
          </div>
        </Reveal>
      </section>
    </>
  );
}
